var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { OrgType } from '../../enum';
import { Autocomplete, DatePicker, ErrorMessageBox, FallbackComponent } from '../common';
import { FormField } from '../common/formField';
import { useCreateBillingLogAPI, useSelectOrganizations } from './selectors';
var BILLING_ORG_TYPES = [OrgType.Genesys];
export var BillingLogDialog = function (_a) {
  var open = _a.open,
    onClose = _a.onClose;
  var t = useTranslation(['manageUser', 'translation']).t;
  var _b = useCreateBillingLogAPI(),
    billingData = _b[0],
    fetchBillingData = _b[1];
  var _c = useState(OrgType.Genesys),
    selectedOrgType = _c[0],
    setSelectedOrgType = _c[1];
  var _d = useSelectOrganizations(selectedOrgType),
    companiesData = _d[0],
    fetchCompanies = _d[1],
    clearCompanies = _d[2];
  var defaultValues = useMemo(function () {
    return {
      start: moment().utc().startOf('y'),
      end: moment().utc(),
      system: BILLING_ORG_TYPES[0],
      company: -1
    };
  }, []);
  var validateForm = yup.object().shape({
    start: yup.object().nullable().required(),
    end: yup.object().nullable().required(),
    system: yup.string().nullable(),
    company: yup.number().nullable(),
    startError: yup.string().optional().max(0, 'Invalid'),
    endError: yup.string().optional().max(0, 'Invalid')
  });
  var _e = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(validateForm)
    }),
    control = _e.control,
    watch = _e.watch,
    reset = _e.reset,
    handleSubmit = _e.handleSubmit;
  var start = watch().start;
  useEffect(function () {
    if (open) {
      fetchCompanies();
    }
    return clearCompanies;
  }, [clearCompanies, fetchCompanies, open, selectedOrgType]);
  useEffect(function () {
    if (open) {
      reset(defaultValues);
    }
  }, [defaultValues, open, reset]);
  useEffect(function () {
    if (billingData.data) {
      onClose();
    }
  }, [billingData.data, onClose]);
  var handleFormSubmit = function (formData) {
    fetchBillingData(formData);
  };
  return _jsx(Dialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: _jsxs(Box, __assign({
      component: "form",
      onSubmit: handleSubmit(handleFormSubmit)
    }, {
      children: [_jsx(DialogTitle, __assign({
        variant: "h2"
      }, {
        children: t('billingLog.title')
      })), _jsx(DialogContent, {
        children: _jsxs(FallbackComponent, __assign({
          requesting: !!companiesData.requesting,
          overlay: true
        }, {
          children: [_jsx(Typography, __assign({
            variant: "body1",
            marginBottom: 4
          }, {
            children: t('billingLog.subtitle')
          })), _jsx(ErrorMessageBox, {
            errors: [billingData.error, companiesData.error]
          }), _jsxs(Grid, __assign({
            container: true,
            spacing: 4
          }, {
            children: [_jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "start",
                label: t('billingLog.startDate'),
                control: control
              }, {
                children: _jsx(DatePicker, {
                  disableFuture: true,
                  control: control
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                required: true,
                name: "end",
                label: t('billingLog.endDate'),
                control: control
              }, {
                children: _jsx(DatePicker, {
                  minDate: start,
                  disableFuture: true,
                  control: control
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                control: control,
                name: "system",
                label: t('billingLog.system'),
                required: true
              }, {
                children: _jsx(Autocomplete, {
                  options: BILLING_ORG_TYPES,
                  value: selectedOrgType,
                  onChange: setSelectedOrgType
                })
              }))
            })), _jsx(Grid, __assign({
              item: true,
              xs: 6
            }, {
              children: _jsx(FormField, __assign({
                control: control,
                name: "company",
                label: t('billingLog.company'),
                required: true
              }, {
                children: _jsx(Autocomplete, {
                  options: companiesData.data,
                  getOptionLabel: function (c) {
                    return c.name;
                  }
                })
              }))
            }))]
          }))]
        }))
      }), _jsxs(DialogActions, __assign({
        sx: {
          justifyContent: 'space-between'
        }
      }, {
        children: [_jsx(Button, __assign({
          variant: "outlined",
          onClick: onClose
        }, {
          children: t('translation:action.cancel')
        })), _jsx(LoadingButton, __assign({
          variant: "contained",
          type: "submit",
          loading: !!billingData.requesting
        }, {
          children: t('translation:action.export')
        }))]
      }))]
    }))
  }));
};